import React from "react";
import { useSelector } from "react-redux";
import AddIcon from "@material-ui/icons/Add";

import { Header } from "../../../components/headers/header/header.component";
import { NewCampaignBriefModal } from "../../../components/modals/new-campaign-brief-modal/new-campaign-brief-modal.component";

import usePermissions from "../../../hooks/usePermissions";
import * as campaignBriefStore from "../../campaign-brief/store/campaign-brief.store";

export const CampaignBriefsHeader = () => {
  const newCampaignBriefModalErrors = useSelector(campaignBriefStore.getErrors);
  const newCampaignBriefModalOpen = useSelector(campaignBriefStore.isNewBriefModelOpen);
  const userPermissions = usePermissions();

  const onCreateNewCampaign = (data: any) => {
    campaignBriefStore.create(data);
  };

  return (
    <>
      <Header
        title="Campaign Briefs"
        button={{
          action: campaignBriefStore.openNewBriefModal,
          disabled: !userPermissions.manageCampBriefs,
          icon: <AddIcon />,
          title: "New Campaign",
        }}
      />
      <NewCampaignBriefModal
        errors={newCampaignBriefModalErrors}
        isOpen={newCampaignBriefModalOpen}
        onClose={campaignBriefStore.closeNewBriefModal}
        onSubmit={onCreateNewCampaign}
      />
    </>
  );
};
